import { Injectable } from "@angular/core";
import { BehaviorSubject, Subject } from "rxjs";

@Injectable({ providedIn: 'root' })
export class GlobalStateService {

  private openLightBox$ = new Subject<any>();
  public openLightBoxForNote$ = new BehaviorSubject<any>([]);
  public clientPortalRelatedDataChanges$ = new Subject<any>();
  public checkOutDatedData$ = new Subject<any>();

  // Drives the UI disconnection indicator.
  private webSocketConnectionState$ = new BehaviorSubject<{ connected: boolean }>({ connected: false });

  get getWebsocketConnectionState() {
    return this.webSocketConnectionState$.asObservable();
  }

  setWebsocketConnectionState(state: { connected: boolean }) {
    this.webSocketConnectionState$.next(state);
  }

  get getOpenLightboxObservable() {
    return this.openLightBox$.asObservable();
  }

  setOpenLightboxObservable(bit: any) {
    this.openLightBox$.next(bit);
  }

  get getOpenLightboxForNoteObservable() {
    return this.openLightBoxForNote$.asObservable();
  }

  setOpenLightboxForNoteObservable(bit: any) {
    this.openLightBoxForNote$.next(bit);
  }

  setClientPortalRelatedDataChanges() {
    this.clientPortalRelatedDataChanges$.next(null);
  }

  checkOutDatedData() {
    this.checkOutDatedData$.next(null);
  }

  get getClientPortalRelatedDataChangesObservable() {
    return this.clientPortalRelatedDataChanges$.asObservable();
  }

  get checkOutDatedDataObservable() {
    return this.checkOutDatedData$.asObservable();
  }
}